import { FeatureFlags } from './types';

export const devFeatureFlags: FeatureFlags = {};
